import { render, staticRenderFns } from "./ApplicationMessagesView.vue?vue&type=template&id=60810ed8&scoped=true&"
import script from "./ApplicationMessagesView.vue?vue&type=script&lang=js&"
export * from "./ApplicationMessagesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60810ed8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardText})
